export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";